export const initialStatusOptions = {
  font: 2,
  bright: 80,
};
